import { Injectable } from "@angular/core"
import { BehaviorSubject } from "rxjs"
import { ContactData } from "../meta/ContactData.interface"
import { INITIAL_CONTACT_DATA } from "../meta/initial-contact-data.const"

@Injectable({
  providedIn: "root"
})
export class CustomerDataService {
  private readonly _contactData$ = new BehaviorSubject<ContactData>(INITIAL_CONTACT_DATA)
  public readonly contactData$ = this._contactData$.asObservable()

  public getContactData(): ContactData {
    return this._contactData$.getValue()
  }

  public setContactData(contactData: Partial<ContactData>): void {
    this._contactData$.next({
      ...this._contactData$.getValue(),
      ...contactData
    })
  }
}
